import { ClippingStudioProject } from "./clipping-studio-project";

/** Result from POST /api/clipping-studio/projects (draft publication only). */
export interface ClippingStudioCreateProjectResult {
  publicationUid: string;
}

/** Result from GET /api/publications/{publicationUid}/open. */
export interface ClippingStudioOpenProjectResult {
  projectId: number;
  project: ClippingStudioProject;
}

/** Publish metadata columns persisted via PUT /api/clipping-studio/projects/{projectId}. */
export interface PublishMetadataSavePayload {
  publishMetadataJson: string;
  publishMetadataOverridesJson: string;
}

export abstract class IClippingStudioRepository {
  abstract createNewProject(mediaId: number): Promise<ClippingStudioCreateProjectResult>;

  abstract openProject(publicationUid: string): Promise<ClippingStudioOpenProjectResult>;

  abstract saveProject(
    projectId: number,
    project: ClippingStudioProject,
    publishPayload?: PublishMetadataSavePayload,
  ): Promise<void>;

  abstract submitProjectForPublication(
    projectId: number,
    cloneProject: boolean,
  ): Promise<void>;
}
